import { Injectable } from '@angular/core';
import { Configurations } from '../types/configuration.types';
import { AvailabilityUtilsService } from './availability-utils.service';
import { LogisticsRulesDto } from './epi/epi.model';
import { EpiService } from './epi/epi.service';

@Injectable({ providedIn: 'root' })
export class OrderReturnUtilsService {
	constructor(
		private epiService: EpiService,
		private availabilityUtils: AvailabilityUtilsService,
	) {
		this.logisticsRules = this.epiService.logisticsRules;
		this.configurations = this.epiService.configurationData;
	}

	private logisticsRules: LogisticsRulesDto;
	private configurations: Configurations;

	public getFirstDateForOrderPickup() {
		const logisticRulesTimeZoneOffset =
			typeof this.logisticsRules?.TimeZoneOffset !== 'undefined' ? this.logisticsRules.TimeZoneOffset : 0;
		const pickupDate = this.availabilityUtils.getMarketLocalTime(logisticRulesTimeZoneOffset);
		const returnAfterSetHourNotPossibleToday =
			typeof this.logisticsRules?.LogisticRules?.ReturnRequestRules?.ReturnRequestAfterSetHourNotPossibleToday !==
			'undefined'
				? this.logisticsRules.LogisticRules.ReturnRequestRules.ReturnRequestAfterSetHourNotPossibleToday
				: 0;
		const allowedBeforeTimeForToday = this.availabilityUtils.getAllowedBeforeTimeMoment(
			returnAfterSetHourNotPossibleToday,
		);

		if (pickupDate > allowedBeforeTimeForToday) {
			pickupDate.add(1, 'days');
		}

		const holidays = this.configurations.calendarHolidays;

		if (
			this.availabilityUtils.isWeekend(pickupDate) ||
			this.availabilityUtils.isHoliday(pickupDate, this.configurations)
		) {
			this.availabilityUtils.addWeekDays(pickupDate, 1, holidays);
		}

		return pickupDate;
	}

	public getReturnDateDisabled() {
		return typeof this.logisticsRules?.LogisticRules?.ReturnRequestRules?.DisableDateSelection !== 'undefined'
			? this.logisticsRules.LogisticRules.ReturnRequestRules.DisableDateSelection
			: true;
	}
}
